export const scrollToStep = (index) => {
    document
        .getElementById(`screen${index + 1}`)
        .scrollIntoView({ behavior: "smooth" });
};
